import React from 'react'
import { CopyrightStyled } from './styles'

const Copyright = ({ ...props }) => {
  return <CopyrightStyled>Copyright &copy; Dan Dan 2019</CopyrightStyled>
}

export default Copyright
